/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

// import Types from '../../../common/modules/types';

const isNotWhiteSpace = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'WHITE_SPACE',
]);

export default [
  ...[
    getFilterWithCol(['FieldSelect', {
      label: null,
      name: 'white_space_value',
      initialValue: 'NORMAL',
      prefix: 'White Space:',
      block: true,
      choices: [{
        label: 'Normal',
        value: 'NORMAL',
      }, {
        label: 'No Wrap',
        value: 'NOWRAP',
      }, {
        label: 'Pre',
        value: 'PRE',
      }, {
        label: 'Pre Wrap',
        value: 'PRE_WRAP',
      }, {
        label: 'Pre Line',
        value: 'PRE_LINE',
      }, {
        label: 'Break Spaces',
        value: 'BREAK_SPACES',
      }],
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotWhiteSpace, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
